import { render } from "./SearchDocumentationMenu.vue?vue&type=template&id=29d1a630"
import script from "./SearchDocumentationMenu.vue?vue&type=script&lang=js"
export * from "./SearchDocumentationMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__